var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addEditForm" },
    [
      _c("div", { staticClass: "formTitle" }, [_vm._v("新增省份Logo")]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "150px", model: _vm.logoInfo } },
        [
          _c(
            "el-row",
            { staticClass: "margin24 bannerBox" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "所属省份：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.logoInfo.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.logoInfo, "title", $$v)
                      },
                      expression: "logoInfo.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "页脚文字：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.logoInfo.footer,
                      callback: function ($$v) {
                        _vm.$set(_vm.logoInfo, "footer", $$v)
                      },
                      expression: "logoInfo.footer",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "开启专家承诺：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.logoInfo.expertAuthentication,
                        callback: function ($$v) {
                          _vm.$set(_vm.logoInfo, "expertAuthentication", $$v)
                        },
                        expression: "logoInfo.expertAuthentication",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "首页Logo上传：" } },
                [_c("FileImg", { on: { successUpLoad: _vm.successUpLoad } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登录Logo上传：" } },
                [_c("FileImg", { on: { successUpLoad: _vm.successUpLoad2 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "后台Logo上传：" } },
                [_c("FileImg", { on: { successUpLoad: _vm.successUpLoad3 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新闻中心banner：" } },
                [
                  _c("FileImg", {
                    attrs: { propImg: _vm.propImg4 },
                    on: { successUpLoad: _vm.successUpLoad4 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "专业资源库banner：" } },
                [
                  _c("FileImg", {
                    attrs: { propImg: _vm.propImg8 },
                    on: { successUpLoad: _vm.successUpLoad5 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "在线精品课banner：" } },
                [
                  _c("FileImg", {
                    attrs: { propImg: _vm.propImg5 },
                    on: { successUpLoad: _vm.successUpLoad5 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "视频公开课banner：" } },
                [
                  _c("FileImg", {
                    attrs: { propImg: _vm.propImg6 },
                    on: { successUpLoad: _vm.successUpLoad6 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "赛事专栏banner：" } },
                [
                  _c("FileImg", {
                    attrs: { propImg: _vm.propImg7 },
                    on: { successUpLoad: _vm.successUpLoad7 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }